import styled, { css } from 'styled-components';
import { BasedCardsContainer } from '../../ui/CardsLayout/styled';
import {
  PlaceholderCardList,
  PlaceholderSection
} from '../../Placeholders/SectionPlaceholder/styled';
import { FlexColumn } from '../../../styled/common';
import { PlaceholderCard } from '../../Placeholders/ItemCardPlaceholder/styled';

export const MIN_RESULT_HEIGHT = 638;

export const noConnectionViewStyles = (minHeight: number) => css`
  && {
    justify-content: center;
    width: 100%;
    min-height: ${minHeight}px;
    margin: 0;
    padding: 15px;
    background-color: inherit;
  }

  && > * {
    margin: 0;
  }

  && > * + * {
    margin-top: 10px;
  }
`;

export const FormStyled = styled.form`
  margin-bottom: 40px;
  border-radius: 21px;

  @media (max-width: ${({ theme }) => theme.tabletBreakpoint}) {
    background-color: ${({ theme }) => theme.colors.background.primary};
    padding: 15px;
  }
`;

export const PashaCardsContainer = styled(BasedCardsContainer)`
  min-height: ${MIN_RESULT_HEIGHT}px;

  > div {
    height: min-content;

    &:not(:nth-last-child(-n + 5)) {
      margin-bottom: 10px;
    }

    @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
      &:not(:nth-last-child(-n + 5)) {
        margin-bottom: 65px;
      }
    }

    .price-container {
      gap: 5px;
    }
  }
`;

export const OffersSectionContainer = styled(FlexColumn)`
  && ${PlaceholderSection} {
    padding: 0;
    min-height: 638px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
      margin-bottom: 0;
    }
  }

  && ${PlaceholderCardList} {
    gap: 10px;
    margin-top: 0;

    &:not(:last-child) {
      margin-bottom: 10px;

      @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
        margin-bottom: 65px;
      }
    }
  }

  && ${PlaceholderCard} {
    width: auto;
    flex: 1;
    margin: 0;
  }
`;
